var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.152 9.05856C10.5739 8.48048 9.63664 8.48048 9.05856 9.05856C8.48048 9.63664 8.48048 10.5739 9.05856 11.152L15.9066 18L9.05856 24.848C8.48048 25.4261 8.48048 26.3634 9.05856 26.9414C9.63664 27.5195 10.5739 27.5195 11.152 26.9414L18 20.0934L24.848 26.9414C25.4261 27.5195 26.3634 27.5195 26.9414 26.9414C27.5195 26.3634 27.5195 25.4261 26.9414 24.848L20.0934 18L26.9414 11.152C27.5195 10.5739 27.5195 9.63664 26.9414 9.05856C26.3634 8.48048 25.4261 8.48048 24.848 9.05856L18 15.9066L11.152 9.05856Z",
    fill: "currentColor"
  })));
};
export default SvgClose;